import { Tracker } from 'services/tracking';
import { HOSTED_PAGE_TYPES, GA_CATEGORIES } from 'consts';

export const trackShowButton = () => {
  const tracker = new Tracker(HOSTED_PAGE_TYPES.cardIssuing);

  tracker.fireEvent({
    action: GA_CATEGORIES.SHOW_BTN
  });
};

export const trackCardActivationAction = (actionName, actionStatus) => {
  const tracker = new Tracker(HOSTED_PAGE_TYPES.cardIssuingActivate);
  if (!actionName) return;

  tracker.fireEvent({
    category: actionStatus || actionName,
    action: actionName
  });
};

export const trackCardActivationPageLoad = () => {
  const tracker = new Tracker(HOSTED_PAGE_TYPES.cardIssuingActivate);

  tracker.fireEvent({
    category: GA_CATEGORIES.ACTIVATE_CARD_PAGE_LOAD,
    action: GA_CATEGORIES.ACTIVATE_CARD_PAGE_LOAD
  });
};

export const trackIssuingPinPageLoad = () => {
  const tracker = new Tracker(HOSTED_PAGE_TYPES.cardIssuingResetPIN);

  tracker.fireEvent({
    category: GA_CATEGORIES.VIEW_PIN_PAGE_LOAD,
    action: GA_CATEGORIES.VIEW_PIN_PAGE_LOAD
  });
};

export const trackResetPinAction = (actionName, actionStatus) => {
  const tracker = new Tracker(HOSTED_PAGE_TYPES.cardIssuingResetPIN);
  if (!actionName) return;

  tracker.fireEvent({
    category: actionStatus || actionName,
    action: actionName
  });
};
